<template>
  <article class="form-container">
    <Title class="title">{{ $t('account_deletion.account_deleted') }}</Title>

    <p class="description" v-if="showForm">
      {{ $t('account_deletion.feedback_description') }}
    </p>
    <form v-on:submit.prevent v-if="showForm">
      <label class="item">
        <input
          name="deletion_reason"
          type="radio"
          value="1"
          @change="updateState"
          v-model.number="reasonDeletion"
        />
        {{ $t('account_deletion.op1_not_using_anymore') }}
      </label>

      <label class="item">
        <input
          name="deletion_reason"
          type="radio"
          value="2"
          @change="updateState"
          v-model.number="reasonDeletion"
        />
        {{ $t('account_deletion.op2_unhappy') }}
      </label>

      <label class="item">
        <input
          name="deletion_reason"
          type="radio"
          value="3"
          @change="updateState"
          v-model.number="reasonDeletion"
        />
        {{ $t('account_deletion.op3_other') }}
      </label>
      <textarea
        :placeholder="$t('account_deletion.text_placeholder')"
        id="w3review"
        name="w3review"
        rows="4"
        cols="50"
        class="textarea"
        @change="updateState"
        v-model="comments"
        v-if="reasonDeletion == 3"
      />
      <button
        :class="{
          'feedback-btn-disabled': !conditions,
          'feedback-btn': conditions,
        }"
        @click="handleFormSubmit"
        :disabled="!conditions"
      >
        {{ $t('account_deletion.submit') }}
      </button>
    </form>

    <p class="success-message" v-if="feedbackSubmitSuccess">
      {{ $t('account_deletion.success_message') }}
    </p>

    <div class="error-message" v-if="error">
      {{ $t('contact.unknown_error') }}
    </div>
  </article>
</template>
<script>
import Title from './Title.vue';

import {
  getRecaptchaToken,
  loadGoogleCaptcha,
  unloadGoogleCaptcha,
} from '../../shared/recaptchaHelper';

export default {
  components: { Title },
  mounted() {
    loadGoogleCaptcha();
  },
  beforeDestroy() {
    unloadGoogleCaptcha();
  },
  data() {
    return {
      feedbackSubmitSuccess: false,
      reasonDeletion: -1,
      error: false,
      showForm: true,
      comments: '',
      conditions: false,
    };
  },
  methods: {
    async handleFormSubmit() {
      const recaptchaToken = await getRecaptchaToken('DELETION_FEEDBACK');
      const formData = new URLSearchParams();
      formData.append('deletion_reason', this.reasonDeletion);
      formData.append('comments', this.comments);
      formData.append('user_uuid', this.$route.params.userUuid);
      formData.append('g-recaptcha-response', recaptchaToken);
      formData.append('token', this.$route.params.token);
      try {
        const result = await fetch(
          `${process.env.VUE_APP_BACKEND_URL}/1.0/user/deletion-feedback/`,
          {
            method: 'post',
            body: formData,
            headers: {
              accept: 'application/json',
              'Content-Type': 'application/x-www-form-urlencoded',
            },
          }
        );
        if (!result.ok) {
          this.error = true;
          this.showForm = false;
        } else {
          this.feedbackSubmitSuccess = true;
          this.showForm = true;
        }
      } catch (e) {
        this.error = true;
      }
      this.updateState();
    },
    updateState() {
      this.conditions =
        this.reasonDeletion !== -1 && !this.feedbackSubmitSuccess;
    },
  },
  async created() {
    const { userUuid } = this.$route.params;
    const { token } = this.$route.params;

    const result = await fetch(
      `${process.env.VUE_APP_USER_SERVICE_URL}/user?uuid=${userUuid}&token=${token}`,
      {
        method: 'delete',
      }
    );

    if (result.ok) {
      this.success = true;
      this.showForm = true;
      return;
    }

    const errorResult = await result.json();

    if (
      errorResult.status === 404 &&
      errorResult.msg_key === 'response_api_err_login_not_found'
    ) {
      this.success = true;
      this.showForm = true;
    } else {
      this.error = true;
      this.showForm = false;
    }
  },
};
</script>

<style>
.error-message {
  margin-top: 0.6em;
  position: relative;
  border: 1px solid #f15c5e;
  padding: 1em 2em;
  border-radius: 5px;
  color: #f15c5e;
}

.success-message {
  margin-top: 40px;
  border-radius: 5px;
  border: 1px solid;
  border-color: #70d38c;
  background-color: #70d38c1a;
  color: #70d38c;
  padding: 1em 2em;
}

.title {
  margin-top: 30px;
}

.description {
  margin-top: 30px;
  margin-bottom: 20px;
  color: #2b4047;
}

.form-container {
  padding-left: 2rem;
  padding-right: 2rem;
}

.item {
  display: block;
  margin-top: 13px;
  margin-bottom: 13px;
  color: #2b4047;
}

.item input {
  margin-right: 20px;
}

.textarea {
  font-size: 14px;
  color: #2b4047;
  width: 100%;
  min-height: 100px;
  padding: 26px;
  border: 1px solid #ecf1f2;
  border-radius: 4px;
  outline: 0;
  box-shadow: 0px 1px 3px #00000029;
  margin-top: 10px;
  margin-bottom: 30px;
}

.feedback-btn {
  color: #2b4047;
  background: #ffdf22;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 30px;
  width: 100%;
  height: 42px;
  opacity: 1;
}

.feedback-btn-disabled {
  color: #2b4047;
  background: #ffdf22;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 30px;
  width: 100%;
  height: 42px;
  opacity: 1;
  opacity: 0.3;
}

/*
======================
       DESKTOP
======================
*/

@media (min-width: 1024px) {
  .title {
    margin-top: 30px;
  }

  .description {
    margin-top: 30px;
    margin-bottom: 20px;
  }

  .form-container {
    padding-left: 15%;
    padding-right: 15%;
  }

  .item {
    display: block;
    margin-top: 13px;
    margin-bottom: 13px;
  }

  .item input {
    margin-right: 20px;
  }
}
</style>
